import React, { useEffect } from "react";
import IconComponent from "../Icons/IconComponent";

const ButtonSkaRound = ({ isDisabled, type, onClick, nameIcon }) => {

    return (
        <button disabled={isDisabled} className={`button-round-${type}` } type='button' style={{ cursor: !isDisabled && onClick ? "pointer" : "defautl" }} onClick={onClick}>
            {
                nameIcon ?
                    <IconComponent nameIcon={nameIcon}/>
                    :
                    null
            }
        </button>
    );
};

export default ButtonSkaRound;
